const initialState = {
  referrals: null,          
  userReferrals: null,          
  referralDetails: null,    
  loading: false,
  error: null,
};

export const referralReducer = (state = initialState, action) => {
  switch (action.type) {
    case "START_LOADING":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "GET_REFERRAL_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_REFERRAL_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        referrals: action.payload,
        error: null,
      };
    case "GET_REFERRAL_LIST_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        referrals: null,
      };

    case "GET_USER_REFERRAL_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_USER_REFERRAL_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        userReferrals: action.payload,
        error: null,
      };
    case "GET_USER_REFERRAL_LIST_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        userReferrals: null,
      };

    case "VIEW_REFERRAL_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "VIEW_REFERRAL_SUCCESS":
      console.log("Reducer VIEW_REFERRAL_SUCCESS payload:", action.payload);
      return {
        ...state,
        loading: false,
        referralDetails: action.payload,
        error: null,
      };
    case "VIEW_REFERRAL_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        referralDetails: null,
      };

    case "STOP_LOADING":
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};
